import React, { FC, useMemo } from 'react';
import { HeaderLink } from './HeaderLink';
import classNames from 'classnames';
import { RoutePath } from '../../enums/RoutePath';
import { MenuItemProps } from '../../interfaces/MenuItemProps';
import './HeaderLinks.scss';
import { HeaderButton } from './HeaderButton';
import { useOpenVilog } from '../../hooks/useOpenVilog';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from "lucide-react";

interface Props {
  className?: string;
}

export const HeaderLinks: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const openVilog = useOpenVilog();
  const links: MenuItemProps[] = useMemo(
    () => [
      {
        title: t('Dashboard'),
        routePath: RoutePath.Home,
      },
      {
        title: t('Assets'),
        routePath: RoutePath.Assets,
      },
      {
        title: t('Customers'),
        routePath: RoutePath.Customers,
      },
      {
        title: t('Transactions'),
        routePath: RoutePath.Transactions,
      },
      {
        title: t('Sites'),
        routePath: RoutePath.Sites,
      },
      {
        title: t('Users'),
        routePath: RoutePath.Users,
      },
      {
        title: t('WhatsApp'),
        routePath: RoutePath.WhatsAppPreferences,
      },
      {
        title: t('Names'),
        routePath: RoutePath.EntityAliases,
      },
      {
        title: (
          <>
            {t('Map')} <ExternalLink size={14} className="mx-2" />
          </>
        ),
        onClick: () => openVilog('/'),
      },
    ],
    [t, openVilog],
  );

  return (
    <div className={classNames('HeaderLinks', className)}>
      {links.map(({ title, routePath, onClick }, index) =>
        onClick ? (
          <HeaderButton onClick={onClick} key={index}>
            {title}
          </HeaderButton>
        ) : (
          <HeaderLink routePath={routePath as RoutePath} key={index}>
            {title}
          </HeaderLink>
        ),
      )}
    </div>
  );
};
